import React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import styles from "./UltrasoundCard.module.scss"; // Import SCSS styles
import CustomButton from "../../../../components/v2/custom-button/CustomButton";
import { useTranslation } from "react-i18next";
import { ArrowIcon } from "../../../../components/icon-components/ArrowIcon";

interface FormattedUltrasoundData {
  imageDate: string;
  imageCount: number;
  imageDetails: {
    imageUrl: string;
    imageName: string;
  }[];
}
interface UltrasoundCardProps {
  formattedData: FormattedUltrasoundData;
  onViewAll: () => void;
}

const UltrasoundCard: React.FC<UltrasoundCardProps> = ({
  formattedData,
  onViewAll,
}) => {
  const { t } = useTranslation();

  return (
    <Box className={styles.ultrasoundWidgetContainer}>
      <Box>
        <ButtonBase onClick={onViewAll}>
          <Typography variant="h3">
            {t("myUltrasounds")}
            <ArrowIcon
              data-testid="arrow-icon"
              className={styles.arrowIcon}
              fill={"black"}
            />
          </Typography>
        </ButtonBase>
        <Typography variant="body1" pt={2}>
          {formattedData.imageDate} | {formattedData.imageCount}{" "}
          {formattedData.imageCount > 1 ? t("images") : t("image")}
        </Typography>
      </Box>

      <Box
        className={`${styles.ultrasoundImages} ${
          formattedData.imageDetails.length === 1 ? styles.singleImage : ""
        }`}
      >
        {formattedData.imageDetails.map(
          (img: { imageUrl: string; imageName: string }, index) => (
            <>
              <img
                src={img.imageUrl}
                alt={img.imageName}
                className={
                  index === 0
                    ? styles.imageBackground
                    : index === 1
                    ? styles.imageForeground
                    : ""
                }
              />
            </>
          )
        )}
      </Box>

      <Box className={styles.buttonContainer}>
        <CustomButton
          variant="outlined"
          onClick={onViewAll}
          text={t("viewAll")}
        />
      </Box>
    </Box>
  );
};

export default UltrasoundCard;
